/*
 * 处方参数弹窗
 */

import React, { useEffect, useMemo, useState } from "react";
import stl from "./rxSelectModal.module.scss";
import { FmButton, FmDrawer, IDrawerProps } from "@/ui-component";
import { useTranslation } from "@/src/i18n/client";
import { odosConfigs, EyeType } from "../ODOS";
import classnames from "classnames";
interface IRxSelectModalProps extends Omit<IDrawerProps, "onChange"> {
    selected: EyeType;
    selectInit: Record<string, number[]>;
    value: number | null | string;
    onChange?: (value: number | null | string) => void;
}

const RxSelectModal: React.FC<IRxSelectModalProps> = (props) => {
    const { t } = useTranslation(["rx", "lens"]);
    const { selectInit, selected, value, onClose, onChange } = props;
    const sphDataKey = useMemo(() => {
        // 根据传入的selected值判断是sph还是cyl
        const key = /cyl/.test(selected) ? "cyl" : "sph";
        return [`min_${key}`, `plus_${key}`];
    }, [selected]);
    const [eyeVal, setEyeVal] = useState(value);
    useEffect(() => {
        setEyeVal(value);
    }, [value]);
    const [showScrollBtn, setShowScrollBtn] = useState(true);
    const [e, setE] = useState({ target: {} });
    //构造select函数

    // const onChange = (val) => {
    //     let e = {};
    //     e.target = {};
    //     if (val > 0) {
    //         val = "+" + parseFloat(val).toFixed(2);
    //     }
    //     e.target.value = val;
    //     e.target.name = this.props.name;

    //     e.persist = () => {};
    //     this.props.onChange(e);
    // };

    // const hideScrollBtn = () => {
    //     setShowScrollBtn(false);
    // };

    // const noneContChange = () => {
    //     if (noneCont.innerText.length > 7) {
    //         noneCont.style.fontSize = "0.22rem";
    //     }
    // };
    // useEffect(() => {
    //     noneContChange();
    // }, []);
    const selectedEyeValue = useMemo(() => odosConfigs[selected], [selected]);
    return (
        <FmDrawer
            open={props.open}
            closeable
            anchor={"bottom"}
            fullHeight
            headerChildren={t(`${selectedEyeValue.title}`)}
            onClose={onClose}
            closeablePosition="right"
            className={stl["rx-select-modal"]}
            headerClassName={stl["select-eye-value-title"]}
            childrenClassName={stl["select-eye-value-children"]}
            horizontal
            footerClassName={stl["footer-container"]}
            footer={
                <>
                    <FmButton
                        fullWidth
                        onClick={(e) => {
                            onClose?.(e, "backdropClick");
                            onChange?.(eyeVal);
                        }}
                        size={"large"}
                    >
                        {t("lens:LimitPrompt.Confirm")}
                    </FmButton>
                    <FmButton
                        className={stl["cancel"]}
                        fullWidth
                        size={"large"}
                        variant="outlined"
                        onClick={(e) => onClose?.(e, "backdropClick")}
                    >
                        {t("lens:LimitPrompt.Cancel")}
                    </FmButton>
                </>
            }
        >
            <div className={stl["rx-select-container"]}>
                <div className={stl["select-item-container"]}>
                    {sphDataKey.map(
                        (sphKey) =>
                            selectInit[sphKey] && (
                                <div
                                    key={sphKey}
                                    className={stl["select-item"]}
                                >
                                    <p className={stl["select-item-title"]}>
                                        {/min/.test(sphKey)
                                            ? t("rx:MinusValues")
                                            : t("rx:PlusValues")}
                                    </p>
                                    <div
                                        className={classnames(
                                            stl["select-item-ul"],
                                            /min/.test(sphKey)
                                                ? stl["left-bg"]
                                                : stl["right-bg"],
                                        )}
                                    >
                                        {/* 小端有默认值，点击则表示选择null */}
                                        {/min/.test(sphKey) && (
                                            <div
                                                id="noneCont"
                                                className={classnames({
                                                    [stl["active"]]: !eyeVal,
                                                })}
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    fontSize: "0.28rem",
                                                }}
                                                onClick={() => {
                                                    setEyeVal(null);
                                                }}
                                            >
                                                {t(
                                                    `${selectedEyeValue.defaultValue.label}`,
                                                )}
                                            </div>
                                        )}
                                        {selectInit[sphKey].map((val, key) => (
                                            <div
                                                // ${parseInt((key + 1) / 2) % 2 ? 'sub' : ''} 二倍取余
                                                className={classnames(val, {
                                                    [stl["active"]]:
                                                        eyeVal ===
                                                        ((/plus/.test(sphKey)
                                                            ? `+${val}`
                                                            : val) ?? null),
                                                })}
                                                key={key}
                                                onClick={(e) => {
                                                    setEyeVal(
                                                        (/plus/.test(sphKey)
                                                            ? `+${val}`
                                                            : val) ?? null,
                                                    );
                                                }}
                                            >
                                                {/* 大端表示需要前置+ */}
                                                {/plus/.test(sphKey) && "+"}
                                                {`${val}`}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ),
                    )}
                </div>
            </div>
        </FmDrawer>
    );
};

export default RxSelectModal;
